(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-discovery-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-discovery-flow')) return;

    const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
    const lerp = (a, b, t) => a + (b - a) * t;
    const smooth = (t) => { t = clamp(t); return t * t * (3 - 2 * t); };
    const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    const easeIn = (t) => { t = clamp(t); return t * t * t; };
    const smoothstep = (edge0, edge1, x) => (edge1 <= edge0 ? (x >= edge1 ? 1 : 0) : smooth((x - edge0) / (edge1 - edge0)));

    // Portion of the total scroll progress in which products travel.
    const MOVE_START = 0.04;
    const MOVE_END = 0.9;

    class ProductDiscoveryFlow extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      init() {
        if (this._ready || !this.isConnected) return;
        this._ready = true;

        this.track = this.querySelector('.pdflow__track');
        this.stage = this.querySelector('.pdflow__stage');
        this.intro = this.querySelector('[data-intro]');
        this.finalHeading = this.querySelector('[data-final-heading]');
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.layer = this.querySelector('.pdflow__items');
        if (!this.track || !this.stage || !this.layer) return;

        this.showIndicators = this.dataset.indicators === 'true';
        const smoothing = clamp(parseFloat(this.dataset.smoothing) || 0, 0, 100);
        this.ease = 0.05 + (1 - smoothing / 100) * 0.25;

        // Each item's local travel (0 to 1) is split into three phases:
        // enter (start -> mid), hold (paused at mid, label visible), and
        // snap (mid -> destination). "holdFrac" is how much of that travel
        // is spent paused at the mid position, stretching that phase so it
        // reads as the highlighted "introduction" moment.
        const holdFrac = clamp((parseFloat(this.dataset.hold) || 35) / 100, 0.1, 0.7);
        const remaining = 1 - holdFrac;
        this.enterEnd = remaining * 0.4;
        this.holdEnd = this.enterEnd + holdFrac;

        this.items = Array.from(this.querySelectorAll('[data-item]')).map((el) => this.buildItem(el));

        this.current = 0;
        this.target = 0;
        this.visible = true;
        this.pin = 0;
        this.scrollLen = 1;

        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => this.setMode();
        this.reduce.addEventListener('change', this.onMotionChange);

        this.onScroll = () => {
          if (this.mode !== 'scroll') return;
          this.target = this.computeProgress();
          if (!this.visible) {
            this.current = this.target;
            return;
          }
          this.kick();
        };

        this.onResize = () => {
          if (this._resizeRaf) return;
          this._resizeRaf = requestAnimationFrame(() => {
            this._resizeRaf = 0;
            this.layout();
            this.refresh();
          });
        };

        this.onFocusIn = () => {
          if (this.mode === 'scroll' && this.current < 0.97) {
            const top = this.track.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: top - this.pin + this.scrollLen, behavior: 'instant' });
          }
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.grid && this.grid.addEventListener('focusin', this.onFocusIn);

        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(this.stage);

        this.io = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible) this.refresh();
          },
          { rootMargin: '100px 0px' }
        );
        this.io.observe(this.track);

        this.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
        });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);

        this.setMode();
      }

      teardown() {
        if (!this._ready) return;
        this._ready = false;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.grid) this.grid.removeEventListener('focusin', this.onFocusIn);
        if (this.reduce) this.reduce.removeEventListener('change', this.onMotionChange);
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        cancelAnimationFrame(this.raf);
        cancelAnimationFrame(this._resizeRaf);
        this.raf = 0;
        this._resizeRaf = 0;
      }

      buildItem(el) {
        const d = el.dataset;
        const num = (key, fallback = 0) => {
          const v = parseFloat(d[key]);
          return Number.isFinite(v) ? v : fallback;
        };
        const startRot = num('rot');
        const endRot = num('endRot');
        const item = {
          el,
          dest: Math.max(1, Math.round(num('dest', 1))) - 1,
          x: num('x'),
          y: num('y'),
          startDepth: num('depth'),
          startScale: num('scale', 100) / 100,
          startRot,
          endRot,
          // The mid pose has no dedicated rotation/tilt setting: the item
          // settles halfway between its start and end rotation, upright
          // (no tilt), for a clean "presentation" pose while it's held.
          midRot: lerp(startRot, endRot, 0.5),
          tilt: num('tilt'),
          midX: num('midX'),
          midY: num('midY'),
          midDepth: num('midDepth'),
          midScale: num('midScale', 140) / 100,
          delay: num('delay') / 100,
          span: Math.max(0.05, num('span', 80) / 100),
          curve: num('curve') / 100,
          spin: num('spin'),
          primary: d.primary === 'true',
          pill: null,
        };

        if (this.showIndicators && d.label) {
          const pill = document.createElement('span');
          pill.className = 'pdflow__pill';
          const dot = document.createElement('i');
          dot.className = 'pdflow__dot';
          const text = document.createElement('span');
          text.textContent = d.label;
          pill.append(dot, text);
          this.layer.appendChild(pill);
          item.pill = pill;
        }
        return item;
      }

      setMode() {
        const animate =
          this.dataset.enabled === 'true' &&
          !this.reduce.matches &&
          this.cards.length > 0 &&
          this.items.length > 0;

        this.mode = animate ? 'scroll' : 'static';
        this.classList.toggle('is-scroll', animate);
        this.classList.toggle('is-static', !animate);
        this.classList.remove('is-complete');

        if (!animate) {
          this.cards.forEach((c) => { c.style.opacity = ''; c.style.transform = ''; });
          if (this.intro) { this.intro.style.opacity = ''; this.intro.style.transform = ''; this.intro.style.visibility = ''; }
          if (this.finalHeading) { this.finalHeading.style.opacity = ''; this.finalHeading.style.transform = ''; }
        }

        this.layout();
        this.refresh();
      }

      // Distance from the stage's left/top edge, ignoring transforms.
      offsetWithin(el) {
        let x = 0;
        let y = 0;
        let node = el;
        while (node && node !== this.stage) {
          x += node.offsetLeft;
          y += node.offsetTop;
          node = node.offsetParent;
        }
        return { x, y };
      }

      layout() {
        if (!this.stage) return;
        const scroll = this.mode === 'scroll';

        this.stageW = this.stage.offsetWidth;
        this.stageH = this.stage.offsetHeight;

        if (scroll) {
          this.track.style.setProperty('--pdflow-stage-h', this.stageH + 'px');
          this.pin = parseFloat(getComputedStyle(this.stage).top) || 0;
          this.scrollLen = Math.max(1, this.track.offsetHeight - this.stageH);
        } else {
          this.track.style.removeProperty('--pdflow-stage-h');
        }

        if (!this.cards.length) return;

        const groups = new Map();
        this.items.forEach((it) => {
          const idx = it.dest % this.cards.length;
          it.card = this.cards[idx];
          if (!groups.has(idx)) groups.set(idx, []);
          groups.get(idx).push(it);
        });

        groups.forEach((list) => {
          const card = list[0].card;
          const slot = card.querySelector('[data-slot]');
          const slotPos = this.offsetWithin(slot);
          const sw = slot.offsetWidth;
          const sh = slot.offsetHeight;

          // Only one image ends up visible on the card: the item marked as
          // primary, or the first item mapped to this destination.
          const primary = list.find((it) => it.primary) || list[0];
          list.forEach((it) => { it.isPrimary = it === primary; });

          list.forEach((it) => {
            const w = it.el.offsetWidth || 1;
            const h = it.el.offsetHeight || 1;
            it.baseW = w;
            it.baseH = h;

            it.ex = slotPos.x + sw / 2;
            it.ey = slotPos.y + sh / 2;

            if (it.isPrimary) {
              // The primary image fits (contain) the entire destination block.
              it.endScale = Math.min(sw / w, sh / h);
            } else {
              // Others converge toward the same spot, then fade out just
              // before landing, as if merging into the primary image.
              it.endScale = Math.min(sw / w, sh / h) * 0.55;
            }

            it.sx = this.stageW * (0.5 + it.x / 100);
            it.sy = this.stageH * (0.5 + it.y / 100);
            // Mid position is contained within the viewport on every device:
            // -100 places the item's left/top edge at the screen edge, 100
            // places its right/bottom edge at the opposite screen edge, and
            // everything in between stays fully on screen, scaled to the
            // item's own size at its mid scale.
            const midW = it.baseW * it.midScale;
            const midH = it.baseH * it.midScale;
            const availW = Math.max(0, this.stageW - midW);
            const availH = Math.max(0, this.stageH - midH);
            const fracX = (it.midX + 100) / 200;
            const fracY = (it.midY + 100) / 200;
            it.mx = midW / 2 + fracX * availW;
            it.my = midH / 2 + fracY * availH;

            // Bend each leg of the journey (start -> mid, mid -> destination)
            // outward from its straight line, so the path curves rather
            // than travelling in two rigid segments.
            const bend = (x0, y0, x1, y1) => {
              const bx = x1 - x0;
              const by = y1 - y0;
              const d = Math.hypot(bx, by) || 1;
              return {
                cx: (x0 + x1) / 2 + (-by / d) * it.curve * d * 0.6,
                cy: (y0 + y1) / 2 + (bx / d) * it.curve * d * 0.6,
              };
            };
            const c1 = bend(it.sx, it.sy, it.mx, it.my);
            it.c1x = c1.cx;
            it.c1y = c1.cy;
            const c2 = bend(it.mx, it.my, it.ex, it.ey);
            it.c2x = c2.cx;
            it.c2y = c2.cy;

            it.s = MOVE_START + it.delay * (MOVE_END - MOVE_START) * 0.6;
            it.e = Math.min(MOVE_END, it.s + it.span * (MOVE_END - MOVE_START));
          });
        });
      }

      refresh() {
        if (!this._ready) return;
        if (this.mode === 'scroll') {
          this.target = this.computeProgress();
          this.current = this.target;
          this.render(this.current);
        } else {
          this.render(1);
        }
      }

      computeProgress() {
        const top = this.track.getBoundingClientRect().top;
        return clamp((this.pin - top) / this.scrollLen);
      }

      kick() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.tick());
      }

      tick() {
        this.raf = 0;
        const diff = this.target - this.current;
        if (Math.abs(diff) < 0.0005) {
          this.current = this.target;
        } else {
          this.current += diff * this.ease;
        }
        this.render(this.current);
        if (this.current !== this.target) this.kick();
      }

      render(p) {
        const scroll = this.mode === 'scroll';

        if (scroll) {
          if (this.intro) {
            const k = smooth((p - 0.1) / 0.22);
            this.intro.style.opacity = String(1 - k);
            this.intro.style.transform = 'translate3d(0,' + (-k * 40).toFixed(1) + 'px,0) scale(' + (1 - k * 0.04).toFixed(3) + ')';
            this.intro.style.visibility = k >= 1 ? 'hidden' : 'visible';
          }
          if (this.finalHeading) {
            const k = smooth((p - 0.55) / 0.2);
            this.finalHeading.style.opacity = String(k);
            this.finalHeading.style.transform = 'translate3d(0,' + ((1 - k) * 12).toFixed(1) + 'px,0)';
          }
          const n = this.cards.length;
          this.cards.forEach((card, i) => {
            const start = 0.36 + (i / Math.max(1, n)) * 0.3;
            const r = smooth((p - start) / 0.2);
            card.style.opacity = String(r);
            card.style.transform = 'translate3d(0,' + ((1 - r) * 28).toFixed(1) + 'px,0) scale(' + (0.96 + 0.04 * r).toFixed(3) + ')';
          });
          this.classList.toggle('is-complete', p >= 0.97);
        }

        this.items.forEach((it) => {
          if (it.endScale === undefined) return;
          const t = clamp((p - it.s) / (it.e - it.s));

          let x, y, z, rz, ry, rx, sc;

          if (t <= this.enterEnd) {
            // Enter: travel from the start position to the mid ("introduce
            // the item") position.
            const span = this.enterEnd || 1;
            const u = easeInOut(t / span);
            const inv = 1 - u;
            x = inv * inv * it.sx + 2 * inv * u * it.c1x + u * u * it.mx;
            y = inv * inv * it.sy + 2 * inv * u * it.c1y + u * u * it.my;
            z = lerp(it.startDepth, it.midDepth, u);
            rz = lerp(it.startRot, it.midRot, u) + it.spin * Math.sin(Math.PI * u) * 0.5;
            ry = lerp(it.tilt, 0, u);
            rx = -ry * 0.4;
            sc = lerp(it.startScale, it.midScale, u);
          } else if (t <= this.holdEnd) {
            // Hold: pause exactly at the mid position while its label shows.
            x = it.mx;
            y = it.my;
            z = it.midDepth;
            rz = it.midRot;
            ry = 0;
            rx = 0;
            sc = it.midScale;
          } else {
            // Snap: slow start, quick finish into the destination card.
            const span = 1 - this.holdEnd || 1;
            const raw = (t - this.holdEnd) / span;
            const u = easeIn(raw);
            const inv = 1 - u;
            x = inv * inv * it.mx + 2 * inv * u * it.c2x + u * u * it.ex;
            y = inv * inv * it.my + 2 * inv * u * it.c2y + u * u * it.ey;
            z = lerp(it.midDepth, 0, u);
            rz = lerp(it.midRot, it.endRot, u);
            ry = 0;
            rx = 0;
            sc = lerp(it.midScale, it.endScale, u);
          }

          let op = smooth(t / 0.12);
          if (!it.isPrimary) {
            // Merge into the primary image: fade out just before arriving.
            const raw = (1 - this.holdEnd) > 0 ? (t - this.holdEnd) / (1 - this.holdEnd) : 1;
            op *= 1 - smooth((raw - 0.7) / 0.3);
          }

          it.el.style.opacity = op.toFixed(3);
          it.el.style.zIndex = it.isPrimary ? '2' : '1';
          it.el.style.transform =
            'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,' + z.toFixed(1) + 'px) ' +
            'translate(-50%,-50%) ' +
            'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg) ' +
            'scale(' + sc.toFixed(4) + ')';

          if (it.pill) {
            // The label appears only around the hold phase (the middle of
            // the animation), floating just above the item, then disappears
            // again before the item snaps into its destination.
            const fadeInStart = this.enterEnd * 0.75;
            const fadeInEnd = this.enterEnd + (this.holdEnd - this.enterEnd) * 0.3;
            const fadeOutStart = this.holdEnd - (this.holdEnd - this.enterEnd) * 0.2;
            const fadeOutEnd = this.holdEnd + (1 - this.holdEnd) * 0.2;
            const k = smoothstep(fadeInStart, fadeInEnd, t) * (1 - smoothstep(fadeOutStart, fadeOutEnd, t));
            const gap = (it.baseH * sc) / 2 + 14;
            it.pill.style.opacity = k.toFixed(3);
            it.pill.style.transform =
              'translate3d(' + x.toFixed(1) + 'px,' + (y - gap).toFixed(1) + 'px,' + (z + 1).toFixed(1) + 'px) translate(-50%,-100%)';
          }
        });
      }
    }

    customElements.define('product-discovery-flow', ProductDiscoveryFlow);
  })();

  } catch(e) { console.error(e); }
})();
})();
